import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: { name: 'reporting-batches' }
  },
  {
    path: '/not-found',
    name: '404',
    component: () => import('../views/404.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/account-setup',
    name: 'account-setup',
    component: () => import('../views/AccountSetup.vue'),
    props: true
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/account-management',
    name: 'account-management',
    component: () => import('../views/account/AccountManagement.vue')
  },
  {
    path: '/account-management/users/create',
    name: 'create-user',
    component: () => import('../views/account/user/CreateUser.vue')
  },
  {
    path: '/account-management/users/:userId/update',
    name: 'update-user',
    component: () => import('../views/account/user/UpdateUser.vue')
  },
  {
    path: '/account-management/companies/create',
    name: 'create-company',
    component: () => import('../views/account/company/CreateCompany.vue')
  },
  {
    path: '/account-management/companies/:companyId/update',
    name: 'update-company',
    component: () => import('../views/account/company/UpdateCompany.vue')
  },
  {
    path: '/error-management',
    name: 'error-management',
    component: () => import('../views/cms/error-management/ErrorManagement.vue')
  },
  {
    path: '/error-management/update-history/:errorId',
    name: 'error-update-history',
    component: () => import('../views/cms/error-management/ErrorUpdateHistory.vue')
  },
  {
    path: '/error-management/update/:errorId',
    name: 'update-error',
    component: () => import('../views/cms/error-management/UpdateError.vue')
  },
  {
    path: '/narrative-management',
    name: 'narrative-management',
    component: () => import('../views/cms/narrative-management/NarrativeManagement.vue')
  },
  {
    path: '/narrative-management/create',
    name: 'create-narrative',
    component: () => import('../views/cms/narrative-management/CreateNarrative.vue')
  },
  {
    path: '/narrative-management/update/:narrativeId',
    name: 'update-narrative',
    component: () => import('../views/cms/narrative-management/UpdateNarrative.vue')
  },
  {
    path: '/network-insights/submission',
    name: 'network-insights-submission',
    component: () => import('../views/cms/network-insights/Submission.vue')
  },
  {
    path: '/documentation',
    name: 'docs',
    component: () => import('../views/Documentation.vue')
  },
  {
    path: '/link-checker',
    name: 'link-checker',
    component: () => import('../views/LinkChecker.vue')
  },
  {
    path: '/reporting',
    redirect: '/reporting/batches'
  },
  {
    path: '/reporting/batches',
    name: 'reporting-batches',
    component: () => import('../views/ReportingBatches.vue')
  },
  {
    path: '/reporting/batches/:batchId',
    name: 'reporting-batch',
    redirect: to => {
      return {
        name: 'reporting-memory-cookie',
        params: {
          batchId: to.params.batchId,
        }
      }
    }
  },
  {
    path: '/reporting/memory/cookie/:batchId',
    name: 'reporting-memory-cookie',
    component: () => import('../views/ReportingMemoryCookie.vue')
  },
  {
    path: '/reporting/batches/:batchId/audits/:auditId',
    redirect: to => {
      return {
        name: 'report-detail',
        params: {
          auditId: to.params.auditId
        }
      }
    }
  },
  {
    path: '/reporting/batches/:batchId/audits/:auditId/technical-report',
    redirect: to => {
      return {
        name: 'technical-report',
        params: {
          auditId: to.params.auditId
        }
      }
    }
  },
  {
    path: '/reporting/batches/:batchId/audits/:auditId/output-report',
    redirect: to => {
      return {
        name: 'report-detail-output',
        params: {
          auditId: to.params.auditId
        }
      }
    }
  },
  {
    path: '/reporting/batches/:batchId/audits/:auditId/cmp-insights',
    redirect: to => {
      return {
        name: 'report-detail-insights',
        params: {
          auditId: to.params.auditId
        }
      }
    }
  },
  {
    path: '/reporting/audits',
    name: 'reporting-audits',
    component: () => import('../views/ReportingAudits.vue'),
  },
  {
    path: '/reporting/audits/:auditId',
    name: 'report-detail',
    component: () => import('../views/ReportDetail.vue'),
    props: true
  },
  {
    path: '/reporting/audits/:auditId/technical-report',
    name: 'technical-report',
    component: () => import('../views/TechnicalReport.vue'),
    props: true
  },
  {
    path: '/reporting/audits/:auditId/lambda-test-results',
    name: 'lambda-test-results',
    redirect: to => {
      return {
        name: 'lite-results',
        params: {
          auditId: to.params.auditId
        }
      }
    }
  },
  {
    path: '/reporting/audits/:auditId/lite-results',
    name: 'lite-results',
    component: () => import('../views/LiteResults.vue'),
  },
  {
    path: '/reporting/audits/:auditId/output-report',
    name: 'report-detail-output',
    component: () => import('../views/OutputReportV2.vue'),
    props: true
  },
  {
    path: '/reporting/audits/:auditId/cmp-insights',
    name: 'report-detail-insights',
    component: () => import('../views/ReportDetailCMPInsights.vue')
  },
  {
    path: `/reasons-management`,
    name: 'reasons-management',
    component: () => import('../views/cms/reasons-management/ReasonsManagement.vue')
  },
  {
    path: '/companies',
    name: 'companies',
    component: () => import('../views/companies/Companies.vue')
  },
  {
    path: '/companies/create',
    name: 'companies-create',
    component: () => import('../views/companies/CompanyMutate.vue')
  },
  {
    path: '/companies/:companyId/update',
    name: 'companies-update',
    component: () => import('../views/companies/CompanyMutate.vue')
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/users/Users.vue')
  },
  {
    path: '/users/create',
    name: 'users-create',
    component: () => import('../views/users/UserMutate.vue')
  },
  {
    path: '/users/:userId/update',
    name: 'users-update',
    component: () => import('../views/users/UserMutate.vue')
  },
  {
    path: '/api-keys',
    name: 'api-keys',
    component: () => import('../views/companies/APIKeys.vue')
  },
  {
    path: '/cms/advertisers',
    name: 'advertisers',
    component: () => import('../views/cms/advertisers/Advertisers.vue')
  },
  {
    path: '/cms/advertisers/create',
    name: 'advertiser-create',
    component: () => import('../views/cms/advertisers/AdvertiserMutate.vue')
  },
  {
    path: '/cms/advertisers/:advertiserId/update',
    name: 'advertiser-update',
    component: () => import('../views/cms/advertisers/AdvertiserMutate.vue')
  },
  {
    path: '/cms/cmps',
    name: 'cmps',
    component: () => import('../views/cms/cmps/CMPs.vue')
  },
  {
    path: '/cms/cmps/create',
    name: 'cmp-create',
    component: () => import('../views/cms/cmps/CMPMutate.vue')
  },
  {
    path: '/cms/cmps/:cmpId/update',
    name: 'cmp-update',
    component: () => import('../views/cms/cmps/CMPMutate.vue')
  },
  {
    path: '/cms/statuses',
    name: 'statuses',
    component: () => import('../views/cms/statuses/Statuses.vue')
  },
  {
    path: '/cms/statuses/create',
    name: 'status-create',
    component: () => import('../views/cms/statuses/StatusMutate.vue')
  },
  {
    path: '/cms/statuses/:statusId/update',
    name: 'status-update',
    component: () => import('../views/cms/statuses/StatusMutate.vue')
  },
  {
    path: '/cms/networks',
    name: 'networks',
    component: () => import('../views/cms/networks/Networks.vue')
  },
  {
    path: '/cms/networks/create',
    name: 'network-create',
    component: () => import('../views/cms/networks/NetworkMutate.vue')
  },
  {
    path: '/cms/networks/:networkId/update',
    name: 'network-update',
    component: () => import('../views/cms/networks/NetworkMutate.vue')
  },
  {
    path: '/cms/networks/success-criteria',
    name: 'network-success-criteria',
    component: () => import('../views/cms/networks/NetworkSuccessCriteria.vue')
  },
  {
    path: '/cms/platform-content',
    name: 'platform-content',
    component: () => import('../views/cms/platform-content/PlatformContent.vue')
  },
  {
    path: '/cms/moonpull-verification',
    name: 'moonpull-verification-cms',
    component: () => import('../views/cms/moonpull-verification/MoonpullVerificationCMS.vue')
  },
  {
    path: '/cms/access',
    name: 'access-cms',
    component: () => import('../views/cms/access/AccessControl.vue')
  },
  {
    path: '/cms/certification-responsibility',
    name: 'certification-responsibility',
    component: () => import('../views/cms/certification/CertificationResponsibility.vue')
  },
  {
    path: '/cms/certification-responsibility/create',
    name: 'certification-responsibility-create',
    component: () => import('../views/cms/certification/CertificationResponsibilityCreate.vue')
  },
  {
    path: '/cms/guided-results/create',
    name: 'guided-results-create',
    component: () => import('../views/cms/guided-results/GuidedResultsMutate.vue')
  },
  {
    path: '/cms/guided-results/:id/amend',
    name: 'guided-results-amend',
    component: () => import('../views/cms/guided-results/GuidedResultsMutate.vue')
  },
  {
    path: '/cms/guided-results',
    name: 'guided-results',
    component: () => import('../views/cms/guided-results/GuidedResults.vue')
  },
  {
    path: '/cms/whitelist',
    name: 'whitelist',
    component: () => import('../views/cms/whitelisting/Whitelisting.vue')
  },
  {
    path: '/cms/whitelist/:id/update',
    name: 'whitelist-update',
    component: () => import('../views/cms/whitelisting/WhitelistingMutate.vue')
  },
  {
    path: '/cms/audit-count-per-user',
    name: 'audit-count-per-user',
    component: () => import('../views/cms/moonpull-reporting/AuditCountsPerUser.vue')
  },
  {
    path: '/cms/moonpull-reporting',
    name: 'moonpull-reporting-cms',
    component: () => import('../views/cms/moonpull-reporting/MoonpullReporting.vue')
  },
  {
    path: '/moonpull-reporting',
    name: 'moonpull-reporting',
    component: () => import('../views/UAT.vue')
  },
  {
    path: '/enterprise-reporting',
    name: 'enterprise-reporting',
    component: () => import('../views/EnterpriseReporting.vue')
  },
  {
    path: '/superuser-tools',
    name: 'superuser-tools',
    component: () => import('../views/SuperuserTools.vue')
  },
  {
    path: '/scheduling',
    name: 'scheduling',
    component: () => import('../views/Scheduling.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/Support.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/Logout.vue'),
  },
  {
    path: '/link-assurance',
    name: 'link-assurance',
    component: () => import('../views/LinkAssurance.vue'),
  },
  {
    path: '/link-assurance-search',
    name: 'link-assurance-search',
    component: () => import('../views/LinkAssuranceSearch.vue'),
  },
  {
    path: '/moonpull-verification',
    name: 'moonpull-verification',
    component: () => import('../views/MoonpullVerification.vue'),
  },
  {
   path: '/advertiser-certification',
    name: 'advertiser-certification',
    component: () => import('../views/AdvertiserCertification.vue'),
  },
  {
    path: '/reporting/audits/:auditId/webinar-view',
    name: 'webinar-view',
    component: () => import('../views/WebinarView.vue'),
  },
  {
    path: '/dev-playground',
    name: 'dev-playground',
    component: () => import('../views/DevPlayground.vue'),
  },
  {
    path: '/share/issues',
    name: 'share-issues',
    component: () => import('../views/share/Issues.vue'),
  },
  {
    path: '/share/issues/reports',
    name: 'share-issue-reports',
    component: () => import('../views/share/IssueReports.vue'),
  },
  {
    path: '/share/issues/:issueId',
    name: 'share-issue',
    component: () => import('../views/share/IssueDetail.vue'),
  },
  {
    path: '/web-unlocker-journey',
    name: 'web-unlocker-journey',
    component: () => import('../views/WebUnlockerJourney.vue'),
  },
  {
    path: '/internal-advertiser-issue-queue',
    name: 'internal-advertiser-issue-queue',
    component: () => import('../views/InternalAdvertiserIssueQueue.vue'),
  },
  {
    path: '/reporting/atlas/batches/:batchId',
    name: 'reporting-atlas-batch',
    component: () => import('../views/atlas/Batch.vue'),
  },
  {
    path: '/reporting/atlas/audits/:auditId',
    name: 'reporting-atlas-audit',
    component: () => import('../views/atlas/Audit.vue'),
  },

  // Redirect route to facilitate smooth navigation between Nuxt and Classic
  {
    path: '/nuxt-redirect',
    beforeEnter(to) {
      window.location.href = to.query.url as string
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


export default router
